import DSDialog from "./system-design/DSDialog";
import DSDialogContent from "./system-design/DSDialogContent";
import DSDialogActions from "./system-design/DSDialogActions";
import DSPrimaryButton from "./system-design/DSPrimaryButton";
import DSSecondaryButton from "./system-design/DSSecondaryButton";
import DSDialogTitle from "./system-design/DSDialogTitle";

export type ConfirmationModalProps = {
  open: boolean;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
};
const ConfirmationModal = ({
  open,
  message,
  onClose,
  onConfirm,
  title = "Final Confirmation",
  confirmLabel = "Yes",
  cancelLabel = "No",
}: ConfirmationModalProps) => {
  return (
    <DSDialog className="modal-medium" open={open} onClose={onClose}>
      <DSDialogTitle>{title}</DSDialogTitle>
      <DSDialogContent>{message}</DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={onClose}>{cancelLabel}</DSSecondaryButton>
        <DSPrimaryButton onClick={onConfirm}>{confirmLabel}</DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default ConfirmationModal;
